// cents to dollar
export const convertCentsToDollar = (amount: string): number => {
  return parseInt(amount, 10) / 100;
};
